export default __webpack_public_path__ + "static/02-01-teach-simulate-tools-f02f70800c16779e4a98d719dd3cfc7c.gif";